import { useMutation } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { BackfillResult } from '@/lib/types';

/**
 * Replays one vehicle's telemetry through its current calculators.
 *
 * Explicit rather than automatic. Recomputing everything whenever a threshold
 * moves makes a fleet's history change under it without anyone asking, and the
 * numbers a tax logbook was built on are exactly the ones that must not.
 *
 * Not a query: it writes, it is slow, and running it twice is a decision rather
 * than a refetch.
 */
export function useBackfill() {
  return useMutation({
    mutationFn: (input: { vehicleId: string; from: string; to: string }) =>
      apiFetch<BackfillResult>('/v1/admin/intervals/backfill', {
        method: 'POST',
        body: JSON.stringify(input),
      }),
  });
}
